import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { ButtonPreviewWrapper, BuyButtonPreview, CheckoutInfoPreview } from 'components';
import { withLocalization } from 'utils/enhancers';

import { BUTTON_TYPE } from '../constants';

import { Box } from '../style';

function MultilanguageButtonPrewiewComponent({ infoButton, button, value, isCustomButton }) {
  return (
    <Box mt={2}>
      <ButtonPreviewWrapper>
        <BuyButtonPreview button={{ ...button, title: value }} isCustomButton={isCustomButton} />
      </ButtonPreviewWrapper>
      {button.buttonType === BUTTON_TYPE.CHECKOUT && (
        <CheckoutInfoPreview
          infoButton={infoButton}
          checkoutButtonInitial={{ color: button.color.hex, iconUrl: button.iconUrl }}
        />
      )}
    </Box>
  );
}

MultilanguageButtonPrewiewComponent.propTypes = {
  isCustomButton: PropTypes.bool.isRequired,
  infoButton: PropTypes.shape({
    iconUrl: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
  button: PropTypes.shape({
    buttonType: PropTypes.string,
    color: PropTypes.shape({ hex: PropTypes.string }),
    iconUrl: PropTypes.string,
  }).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.shape({ languageCode: PropTypes.string, value: PropTypes.string })),
  ]),
};
MultilanguageButtonPrewiewComponent.defaultProps = { value: '' };

export const MultilanguageButtonPrewiew = withLocalization(memo(MultilanguageButtonPrewiewComponent));
